import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Paper } from '@olxbr/design-system'
import Loading from '../../atoms/LoadingIcon'
import ChangePasswordTemplate from '../../templates/ChangePasswordTemplate'
import medias from '../../../util/medias'

// prettier-ignore
const Content = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

export class ChangePasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      token: props.token,
      isLoading: false,
    }
  }

  render() {
    const {
      onSuccess,
      onSubmit,
      onError,
      disableTokenExchange,
      onTokenExchangeSubmit,
      onTokenExchangeFinish,
      abTests,
      onLinkExpired,
    } = this.props

    return (
      <Content>
        {this.state.isLoading && <Loading />}
        <ChangePasswordTemplate
          disableTokenExchange={disableTokenExchange}
          onTokenExchangeSubmit={onTokenExchangeSubmit}
          onTokenExchangeFinish={onTokenExchangeFinish}
          onSuccess={onSuccess}
          onSubmit={onSubmit}
          onError={onError}
          token={this.state.token}
          onLinkExpired={onLinkExpired}
          abTests={abTests}
        />
      </Content>
    )
  }
}

ChangePasswordPage.propTypes = {
  disableTokenExchange: PropTypes.bool,
  onTokenExchangeSubmit: PropTypes.func,
  onTokenExchangeFinish: PropTypes.func,
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  abTests: PropTypes.string,
  token: PropTypes.string,
  onLinkExpired: PropTypes.func,
}
